function pad(value) {
    return value.toString().padStart(2, '0');
}

function toIsoDate(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function addDays(date, days) {
    const next = startOfDay(date);
    next.setDate(next.getDate() + days);
    return next;
}

function startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export function getTodayRange(today = new Date()) {
    const day = startOfDay(today);
    const iso = toIsoDate(day);
    return { dateFrom: iso, dateTo: iso };
}

export function getTomorrowRange(today = new Date()) {
    const tomorrow = addDays(today, 1);
    const iso = toIsoDate(tomorrow);
    return { dateFrom: iso, dateTo: iso };
}

export function getThisWeekendRange(today = new Date()) {
    const day = startOfDay(today);
    const weekday = day.getDay();

    if (weekday === 0) {
        return { dateFrom: toIsoDate(day), dateTo: toIsoDate(day) };
    }
    if (weekday === 6) {
        return { dateFrom: toIsoDate(day), dateTo: toIsoDate(addDays(day, 1)) };
    }
    const saturday = addDays(day, 6 - weekday);
    return { dateFrom: toIsoDate(saturday), dateTo: toIsoDate(addDays(saturday, 1)) };
}

export function getThisMonthRange(today = new Date()) {
    const reference = startOfDay(today);
    const start = startOfMonth(reference);
    const end = endOfMonth(reference);
    return { dateFrom: toIsoDate(start), dateTo: toIsoDate(end) };
}

export const SHORTCUT_KEYS = Object.freeze({
    today: 'today',
    tomorrow: 'tomorrow',
    thisWeekend: 'thisWeekend',
    thisMonth: 'thisMonth',
});

export const SHORTCUT_RESOLVERS = Object.freeze({
    [SHORTCUT_KEYS.today]: getTodayRange,
    [SHORTCUT_KEYS.tomorrow]: getTomorrowRange,
    [SHORTCUT_KEYS.thisWeekend]: getThisWeekendRange,
    [SHORTCUT_KEYS.thisMonth]: getThisMonthRange,
});
